import * as React from 'react';
import classes from './styles.module.scss';
import Layout from '../../components/Layout';
import { ReactComponent as CheckIcon } from '../../assets/icons/check-icon.svg';
import { ReactComponent as LockIcon } from '../../assets/icons/lock-icon.svg';
import { ReactComponent as LogoutIcon } from '../../assets/icons/logout-icon.svg';
import useService from '../../hooks/useService';
import { WalletService } from '../../service/WalletService';
import { UserService } from '../../service/UserService';
import SKButton from '../../components/UI/SKButton';
import SKModal from '../../components/UI/SkModal';
import SKCard from '../../components/UI/SKCard';
import clsx from 'clsx';
import TransactionHistory from './components/transaction-history';
import EarningHistory from './components/earning-history';
import { useToast } from '@chakra-ui/toast';
import { StorageService } from '../../service/Storage';
import { calculatePercentage, formatNumber, currencyValue } from '../../utils';
import { OfferService } from '../../service/OfferService';
import { ReferralService } from '../../service/ReferralService';
import { Text, Heading, Link, Box } from '@chakra-ui/react';
import {
  DEFAULT_AMOUNT_TO_ENABLE_PAYTM,
  DEFAULT_AMOUNT_TO_ENABLE_UPI,
} from '../../constants';
import UPIInfoModal from './components/UPIInfoModal';
import { useNavigate } from 'react-router-dom';
import { HOME_PAGE } from '../../constants/route.const';
import UserStatistics from './components/UserStatistics';
import SKProgress from 'components/UI/SKProgress';
import { format } from 'date-fns';
import coin from './../../assets/coin.png';
import SKCoin from 'components/UI/SKCoin';
import SuccessModal from 'components/UI/SuccessModal';
import RedeemNotifs from 'components/RedeemNotifs';

import SKCurrency from 'components/UI/SKCurrency';

const UPI_PAYMENT_METHOD = 'UPI';
const PAYTM_PAYMENT_METHOD = 'PAYTM_WALLET';

export default function Profile() {
  const [openRedeemModal, setOpenRedeemModal] = React.useState(false);
  const [prevPayout, setPrevPayout] = React.useState(0);
  const [successModal, setSuccessModal] = React.useState(false);
  const [pollingStatus, setPollingStatus] = React.useState(false);
  const [intervalId, setIntervalId] = React.useState(null);
  const [transactionId, setTransactionId] = React.useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] =
    React.useState(UPI_PAYMENT_METHOD);
  const [upiId, setUPIId] = React.useState();
  const [wid, setWid] = React.useState(null);
  const payoutCtrl = useService(WalletService.getMinimumPayout);
  const balanceCtrl = useService(WalletService.getWalletBalance);
  const totalCoinsCtrl = useService(WalletService.getTotalValue);
  const totalINRCtrl = useService(WalletService.getTotalINREarned);
  const totalOfferCtrl = useService(OfferService.getTotalOfferCompleted);
  const totalReferralCtrl = useService(ReferralService.getTotalReferral);
  const redeemCtrl = useService(WalletService.redeemWallet);
  const transactionCtrl = useService(WalletService.getTransactionDetails);
  const userCtrl = useService(UserService.getProfile);
  const toast = useToast();
  const [recallAfterRedeem, setRecallAfterRedeem] = React.useState(Date.now());
  const navigate = useNavigate();

  const isFromApp = StorageService.getSessionFrom() === 'app';
  const bal = balanceCtrl.data?.balance?.amount;
  const minPayout = payoutCtrl?.data?.minimum_payout?.amount;

  React.useEffect(() => {
    setWid(StorageService.getWId());
  }, []);

  React.useEffect(() => {
    if (!StorageService.getAccessToken()) {
      navigate(HOME_PAGE, { replace: true });
      return;
    }
  }, []);

  React.useEffect(() => {
    if (wid) callAllDetails();
  }, [wid]);

  const callAllDetails = () => {
    userCtrl.call();
    payoutCtrl.call(wid);
    totalCoinsCtrl.call(wid);
    totalINRCtrl.call();
    totalOfferCtrl.call();
    totalReferralCtrl.call();
    balanceCtrl.call(wid);
  };

  const redeemWallet = async e => {
    e.preventDefault();
    if (upiId) {
      const regex = /^\w.+@\w+$/;
      if (!regex.test(upiId)) {
        toast({
          description: 'Please enter a valid UPI ID',
          status: 'error',
          position: 'top',
        });
        return;
      }
    }

    const payload = {
      vpa: upiId,
      paytm_phone_number: userCtrl.data?.phoneNumber,
      payment_gateway:
        selectedPaymentMethod === PAYTM_PAYMENT_METHOD ? 'PAYTM' : 'RAZORPAY',
      payment_method: selectedPaymentMethod,
    };
    setPrevPayout(payoutCtrl?.data?.minimum_payout.amount);
    const data = await redeemCtrl.call(payload, wid);
    setTransactionId(data.transaction_id);
    // toast({ description: 'success!', status: 'success' });

    closeRedeemModal();
    checkTransactionStatus(data.transaction_id);
    setSuccessModal(true);
  };
  const closeSuccessModal = () => {
    setSuccessModal(false);
    callAllDetails(wid);
    setRecallAfterRedeem(Date.now());
    clearInterval(intervalId);
  };
  const closeRedeemModal = () => {
    setOpenRedeemModal(false);
  };

  const payoutProgress = React.useMemo(() => {
    return calculatePercentage(bal, minPayout);
  }, [bal, minPayout]);
  const MINIMUM_UPI_PAYOUT =
    payoutCtrl?.data?.upi_minimum_payout.amount || DEFAULT_AMOUNT_TO_ENABLE_UPI;

  const MINIMUM_PAYTM_PAYOUT =
    payoutCtrl?.data?.paytm_minimum_payout.amount ||
    DEFAULT_AMOUNT_TO_ENABLE_PAYTM;
  const checkTransactionStatus = async tid => {
    setPollingStatus(true);
    let g = 0;
    const r = setInterval(() => {
      transactionCtrl.call({ tid: tid });
      if (++g === 5) {
        setPollingStatus(false);
      }
    }, 2000);
    setIntervalId(r);
    setTimeout(() => {
      clearInterval(r);
    }, 10000);
  };
  let transactionStatus = transactionCtrl?.data;
  return (
    <Layout>
      <RedeemNotifs />
      <div className={classes.UserDetails}>
        <div className={classes.transactions}>
          <SKCard reverse className={classes.overview}>
            <div className={classes.walletBalance}>
              <Heading as="h3" fontSize={'24px'} fontWeight={600}>
                {' '}
                Wallet balance{' '}
              </Heading>
              <div className={classes.box}>
                <div className={classes.icon}>
                  <SKCurrency size={'48px'} />
                </div>
                <div className={classes.amount} id="wallet-balance-amount">
                  {formatNumber(
                    currencyValue(balanceCtrl.data?.balance.amount || 0)
                  )}
                </div>
              </div>
            </div>
            <div className={classes.minimumPayout}>
              <div className={classes.header}>
                <div className={classes.title}>Minimum Payout</div>
                <div className={classes.amount}>
                  <SKCurrency size={'20px'} />
                  {currencyValue(payoutCtrl?.data?.minimum_payout.amount)}
                </div>
              </div>

              <div className={classes.PayoutProgress}>
                <SKProgress value={payoutProgress} size="lg" />
              </div>
              {StorageService.getCurrency() !== 'inr' && (
                <Text
                  color="#323339"
                  fontSize="20px"
                  textAlign="center"
                  m="-10px 0"
                  fontWeight={'bold'}
                >
                  100 Chillars = ₹ 10
                </Text>
              )}
              <div className={classes.action}>
                <SKButton
                  style={{ width: 200 }}
                  onClick={() => setOpenRedeemModal(true)}
                  disabled={payoutProgress < 100}
                  color="white"
                >
                  Redeem Now
                </SKButton>
              </div>
              {payoutProgress < 100 ? (
                <div className={classes.info}>
                  Wallet is Not Ready for Payouts
                </div>
              ) : (
                <div>Wallet is Ready for Payouts</div>
              )}
            </div>
          </SKCard>
          <div className={classes.history}>
            <div className={classes.earningHistory}>
              <h3> Transaction History </h3>
              <EarningHistory key={recallAfterRedeem} />
            </div>
            <div className={classes.transactionHistory}>
              <h3> Withdrawal History </h3>
              <TransactionHistory key={recallAfterRedeem} />
            </div>
          </div>
        </div>

        <SKCard className={classes.profile}>
          <h1>Profile</h1>
          <SKCard className={classes.profileCard}>
            <div className={classes.name}>
              {userCtrl.data?.fullName}
              <span className={classes.pro}>PRO</span>
            </div>
            <div className={classes.phone}>{userCtrl.data?.phoneNumber}</div>
            <div className={classes.email}>{userCtrl.data?.email}</div>
            {userCtrl.data?.createdAt && (
              <div className={classes.earningSince}>
                Earning since {format(userCtrl.data?.createdAt, 'yyyy')}
              </div>
            )}
          </SKCard>
          <h1>Statistics</h1>
          <UserStatistics
            data={{
              coinsEarned: totalCoinsCtrl?.data?.total_earned.amount,
              redeemedAmount: totalINRCtrl?.data?.total_inr_earned,
              offerTried: totalOfferCtrl?.data?.total_offers_tried,
              offerCompleted: totalOfferCtrl?.data?.count,
              referal: totalReferralCtrl?.data?.usage_count,
            }}
          />
          {!isFromApp && (
            <div className={classes.logout}>
              <SKButton
                onClick={() => {
                  StorageService.setAccessToken();
                  StorageService.setRefreshToken();
                  StorageService.setWId();
                  StorageService.setUserId();
                  StorageService.setXPN();
                  navigate(HOME_PAGE);
                }}
                leftIcon={<LogoutIcon fill="#FFFFFF" />}
                color="#FFFFFF"
                variant="ghost"
              >
                Logout
              </SKButton>
            </div>
          )}
        </SKCard>
      </div>

      <SKModal isOpen={openRedeemModal} onClose={closeRedeemModal}>
        <form className={classes.reedeemModal} onSubmit={redeemWallet}>
          <h3 className={classes.modalHeader}>Choose Redeem Method</h3>
          <>
            <CustomCheckBox
              isLocked={
                (balanceCtrl.data?.balance.amount || 0) < MINIMUM_UPI_PAYOUT
              }
              lockTitle={'UPI(LOCKED)'}
              lockSubtitle={
                <LockTitle
                  balanceCtrl={balanceCtrl}
                  MINIMUM_PAYOUT={MINIMUM_UPI_PAYOUT}
                  transactionType="UPI"
                />
              }
              title="UPI"
              onClick={() => setSelectedPaymentMethod(UPI_PAYMENT_METHOD)}
              isSelected={selectedPaymentMethod === UPI_PAYMENT_METHOD}
              subtitle={'eg: 8888999910@oksbi'}
            />
            {selectedPaymentMethod === UPI_PAYMENT_METHOD && (
              <>
                <input
                  className={classes.upiInput}
                  onChange={e => setUPIId(e.target.value)}
                  value={upiId}
                  placeholder={'Enter UPI ID'}
                  required
                />
                <UPIInfoModal />
              </>
            )}
          </>

          {/* <CustomCheckBox
            title="Paytm Wallet"
            lockTitle={'Paytm(LOCKED)'}
            isLocked={
              (balanceCtrl.data?.balance.amount || 0) < MINIMUM_PAYTM_PAYOUT
            }
            lockSubtitle={
              <LockTitle
                balanceCtrl={balanceCtrl}
                MINIMUM_PAYOUT={MINIMUM_PAYTM_PAYOUT}
                transactionType="Paytm"
              />
            }
            onClick={() => setSelectedPaymentMethod(PAYTM_PAYMENT_METHOD)}
            isSelected={selectedPaymentMethod === PAYTM_PAYMENT_METHOD}
            subtitle={
              <div
                style={{
                  color: 'red',
                  fontWeight: 600,
                  whiteSpace: 'break-spaces',
                }}
              >
                Currently experiencing high failure rate!
              </div>
            }
          />
          {selectedPaymentMethod === PAYTM_PAYMENT_METHOD && (
            <ul className={classes.conditions}>
              <li>
                Paytm account's phone number must be the same as that of
                Chillar Pro 
              </li>
              <li>Your Number must be KYC Verified</li>
            </ul>
          )} */}

          <SKButton
            disabled={selectedPaymentMethod === UPI_PAYMENT_METHOD && !upiId}
            isLoading={redeemCtrl.isLoading}
            type="submit"
          >
            Redeem Now
          </SKButton>
        </form>
      </SKModal>
      <SuccessModal
        id={transactionId}
        isOpen={successModal}
        onClose={closeSuccessModal}
        intervalId={intervalId}
        amount={prevPayout}
        transaction={transactionStatus}
        pollingStatus={pollingStatus}
        key={recallAfterRedeem}
      />
    </Layout>
  );
}

function CustomCheckBox({
  title,
  subtitle,
  onClick,
  isSelected,
  isLocked,
  lockTitle,
  lockSubtitle,
}) {
  return (
    <div
      className={
        isLocked
          ? clsx(classes.CustomCheckBox2)
          : clsx(classes.CustomCheckBox, isSelected && classes.selected)
      }
      onClick={isLocked ? () => {} : onClick}
    >
      {isLocked ? <LockIcon /> : <CheckIcon />}
      <div className={classes.content}>
        <div className={classes.title}>{isLocked ? lockTitle : title}</div>
        <div className={classes.subtitle}>
          {isLocked ? lockSubtitle : subtitle}
        </div>
      </div>
    </div>
  );
}

const LockTitle = ({
  balanceCtrl,
  MINIMUM_PAYOUT,
  transactionType = 'UPI',
}) => {
  const jsx = (
    <span
      style={{
        color: 'var(--subtitle-color)',
        display: 'flex',
        alignItems: 'center',
        margin: '0 4px',
      }}
    >
      <img
        src={coin}
        width="20px"
        height="20px"
        style={{ marginRight: '4px' }}
        alt="Chillar Pro  logo"
      />{' '}
      {MINIMUM_PAYOUT - balanceCtrl.data?.balance.amount}
    </span>
  );
  return (
    <div style={{ display: 'flex' }}>
      Earn {jsx} more for {transactionType} transaction
    </div>
  );
};
